module.exports = __webpack_public_path__ + "c8ebf2009563e57f0b27093fbf03a9bf.woff2";